
export default {
	props: {
		dateString: {
			type: String,
			default: null
		}
	} 
}
